import apiRequest from './handler';

const NotificationService = {
    /**
     * Fetches unread notifications for support users
     * @param {function} setIsAuthenticated - Function to update authentication state
     * @param {function} navigate - Function to navigate to a different route
     * @returns {Promise} - A promise that resolves to the server's response
     */
    getUnreadNotifications: async (setIsAuthenticated, navigate) => {
        try {
            const response = await apiRequest(
                '/support/notifications/unread',
                'GET',
                null,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error fetching unread notifications:', error);
            throw error;
        }
    },

    /**
     * Marks a notification as read or marks all notifications as read
     * @param {number|string|null} notificationId - The ID of the notification to mark as read, or null to mark all as read
     * @param {function} setIsAuthenticated - Function to update authentication state
     * @param {function} navigate - Function to navigate to a different route
     * @returns {Promise} - A promise that resolves to the server's response
     */
    markNotificationAsRead: async (notificationId, setIsAuthenticated, navigate) => {
        try {
            const requestData = notificationId ? { notification_id: notificationId } : {};
            
            const response = await apiRequest(
                '/support/notifications/mark-read',
                'POST',
                requestData,
                true,
                setIsAuthenticated,
                navigate
            );
            return response;
        } catch (error) {
            console.error('Error marking notification(s) as read:', error);
            throw error;
        }
    }
};

export default NotificationService;